import Resource from '@/api/core/resource'

class Institucion extends Resource {
  constructor () {
    super('administracion/instituciones')
  }

  obtenerInstitucionImpresion (institucionId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(institucionId)
        .concat('/impresion')
    )
  }

  obtenerObrasSocialesInstitucion (institucionId) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(institucionId)
        .concat('/obras_sociales')
    )
  }
}

export default new Institucion()
